import * as yup from "yup";
import BaseForm from "../../../../../../shared/components/form/BaseForm";
import FormSelect from "../../../../../../shared/components/select/FormSelect";
import { useState } from "react";

const AddCCSectionRoleForm = ({ onSubmitHandler, roles }) => {
  const validationSchema = yup.object({
    role: yup.string().required("El rol es obligatorio"),
    section: yup.string().required("La sección es obligatoria"),
  });

  const defaultValues = {
    role: "",
    section: "",
  };

  const [sections, setSections] = useState([
    { label: "Tools", value: "tools" },
    { label: "Dashboards", value: "dashboards" },
    { label: "Data explorers", value: "data-explorers" },
  ]);

  return (
    <BaseForm
      onSubmitHandler={onSubmitHandler}
      validationSchema={validationSchema}
      defaultValues={defaultValues}
    >
      <FormSelect name="role" label="Roles" options={roles} />
      <FormSelect name="section" label="Secciones" options={sections} />
    </BaseForm>
  );
};

export default AddCCSectionRoleForm;
